import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { timer } from 'rxjs';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';

@Component({
  selector: 'app-event-pot-size-component',
  templateUrl: './event-pot-size-component.component.html',
  styleUrls: ['./event-pot-size-component.component.css']
})
export class EventPotSizeComponentComponent implements OnInit {

  public currentPotSize = 0;
  public eventEventId = 0;
  public theme = 'dark';

  constructor(
    private cue5050Service: Cue5050Service,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.route.params
        .subscribe(params => {
          this.eventEventId = params['id'];
          
          if(params['theme'] === 'light') {
            this.theme = 'light';
          }

          this.getCurrentPotSize();
          
          const refreshTimer = timer(5000, 10000).subscribe((v) => {
            this.getCurrentPotSize();
          });
        });
    
  }

  getCurrentPotSize() {
    if (this.eventEventId < 1)
      return;

    this.cue5050Service.getCurrentPot(this.eventEventId).subscribe(
      result => {
        this.currentPotSize = result.potSize / 100;
      }
    );
  }

}
